<template>
    <div v-if="!ended">
        <slot></slot>
    </div>
</template>

<script>
import eventBus from '@/event-bus';

export default {
    props: {
        modalId: {
            type: String
        }
    },
    data() {
        return {
            ended: false,
        }
    },
    mounted() {
        eventBus.$on('videoEnded', this.videoEnded);
    },
    methods: {
        videoEnded(event) {
            if (this.modalId === event.modalId) {
                this.ended = true;
            }
        }
    }
}
</script>
